import { useCallback } from "react";
import { UserAccountApi, useAPIAction } from "melco-shared-logic";

export const useDisableUser = (userIdToDisable?: string) => {

    const [disableUser] = useAPIAction(

        UserAccountApi,
        async (api: UserAccountApi) => {
            const data = await api.accountDisable();

            return {
                successMessages: [{ message: "default" },],
                data,
            };
        },
        {
            defaultApiConfigOptions: { impersonationForId: userIdToDisable },
            translationPrefix: "users.actions.disable",
        }
    );

    return useCallback(
        async () => {

            await disableUser();


            return { success: true };
        },
        [disableUser]
    );
};
